<template>
  <div>
    <v-card
      outlined
    >
      <v-list-item
        three-line
      >
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
          >
            Push-ilmoitukset (beta)
          </v-list-item-title>

          <v-list-item-subtitle>
            Vastaanota ilmoituksia uusista julkaisuista ja kommenteista
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-avatar
          tile
          size="64"
          color="primary"
        >
          <v-icon
            dark
            size="32"
          >
            notifications
          </v-icon>
        </v-list-item-avatar>
      </v-list-item>

      <v-card-actions>
        <v-switch
          :hint="hint"
          :disabled="!supportsPushNotifications"
          :input-value="hasValidWebpushSubscriptionForThisDevice"
          :loading="$wait.is('updating push notifications')"
          persistent-hint
          class="pt-0 mt-0 pl-2 pb-4"
          color="secondary"
          label="Ota käyttöön"
          @change="onChange"
        />
      </v-card-actions>

      <v-card-text
        v-if="hasValidWebpushSubscriptionForThisDevice"
        class="pt-0"
      >
        <v-divider
          class="pb-2"
        />

        <v-subheader class="pl-0">
          Lähetä ilmoitus, kun...
        </v-subheader>

        <v-checkbox
          v-model="selectedNotificationTypes"
          v-for="(option, i) in notificationOptions"
          :key="i"
          class="mt-0"
          :hint="option.subtitle"
          :persistent-hint="!!option.subtitle"
          :hide-details="!option.subtitle"
          :value="option.value"
          :disabled="option.disabled"
        >
          <template
            v-slot:label
          >
            <span
              class="caption"
            >
              {{ option.title }}
            </span>
          </template>
        </v-checkbox>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapWaitingActions } from 'vue-wait';

export default {
  computed: {
    ...mapGetters({
      supportsPushNotifications: 'webpush/supportsPushNotifications',
      notificationPermissionDenied: 'webpush/notificationPermissionDenied',
      pushSubscription: 'webpush/pushSubscription',
      pushSubscriptions: 'webpush/pushSubscriptions',
      hasValidWebpushSubscriptionForThisDevice: 'webpush/hasValidWebpushSubscriptionForThisDevice',
      user: 'currentUser/user',
    }),

    hint() {
      if (this.supportsPushNotifications) return 'Ilmoitukset saapuvat tälle laitteelle';

      return 'Selaimesi tai laitteesi ei tue push-ilmoituksia';
    },

    notificationOptions() {
      return [
        {
          title: 'Saan uuden kuvan tai kommentin julkaisuuni',
          value: 'OWN_THREAD_WAS_COMMENTED',
        },
        {
          title: 'Minut mainitaan kommentin tägillä (esim. @2)',
          value: 'NEW_MENTION_IN_A_THREAD',
        },
        {
          title: 'Julkaisustani tykätään (tulossa)',
          disabled: true,
          value: 'OWN_RECORD_WAS_LIKED',
        },
        {
          title: 'Alueellani julkaistaan uusi kuva (tulossa)',
          disabled: true,
          value: 'NEW_RECORD_IN_MY_AREA',
        },
        {
          title: 'Seuraamaani lankaan lisätään uusi kuva (tulossa)',
          disabled: true,
          value: 'NEW_PIC_IN_A_THREAD',
        },
        {
          title: 'Seuraamaani lankaan lisätään uusi kommentti (tulossa)',
          disabled: true,
          value: 'NEW_COMMENT_IN_A_THREAD',
        },
      ];
    },

    selectedNotificationTypes: {
      get() {
        return this.user.webpushNotificationTypes;
      },

      set(webpushNotificationTypes) {
        this.updateUser({
          user: {
            webpushNotificationTypes,
          },
        });
      },
    },
  },

  methods: {
    ...mapWaitingActions('webpush', {
      subscribeToWebpush: 'updating push notifications',
      unsubscribeFromWebpush: 'updating push notifications',
    }),

    ...mapWaitingActions('currentUser', {
      updateUser: 'updating user',
    }),

    onChange(subscribed) {
      if (subscribed) {
        this.subscribeToWebpush();
      } else {
        this.unsubscribeFromWebpush();
      }
    },
  },
};
</script>
